module.exports = __webpack_public_path__ + "img/pro5.4f36bada.png";